// extracted by mini-css-extract-plugin
module.exports = {"btn":"featureBtn-module--btn--1aweG","active":"featureBtn-module--active--15PVZ"};